var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgEnvelopeIcon = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 16,
    viewBox: "0 0 21 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.2258 0H4.90323C2.19974 0 0 2.19974 0 4.90323V11.0968C0 13.8003 2.19974 16 4.90323 16H15.2258C17.9293 16 20.129 13.8003 20.129 11.0968V4.90323C20.129 2.19974 17.9293 0 15.2258 0ZM4.90323 1.54839H15.2258C16.6235 1.54839 17.8219 2.40923 18.3257 3.62626L11.9257 7.89365C10.7953 8.64616 9.33368 8.64616 8.20438 7.89365L1.80437 3.62626C2.30708 2.4082 3.50555 1.54839 4.90323 1.54839ZM15.2258 14.4516H4.90323C3.05342 14.4516 1.54839 12.9466 1.54839 11.0968V5.31716L7.34451 9.18196C8.17031 9.73215 9.1169 10.0077 10.0645 10.0077C11.0111 10.0077 11.9577 9.73215 12.7845 9.18196L18.5806 5.31716V11.0968C18.5806 12.9466 17.0756 14.4516 15.2258 14.4516Z",
    fill: "#0088FF"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgEnvelopeIcon);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/envelopeIcon.84de12c2cb0572ac474a787d4cd06659.svg";